import { collection, getCountFromServer } from 'firebase/firestore';

import { db } from '../../config';

export const getCollectionLength = async (collectionPath: string): Promise<number> => {
  try {
    const collectionRef = collection(db, collectionPath);
    const countSnapshot = await getCountFromServer(collectionRef);
    return countSnapshot.data().count;
  } catch (error) {
    /* eslint-disable-next-line no-console */
    console.error('Error getting collection length:', error);
    throw error;
  }
};
